<template>
  <v-dialog :value="isDialogRendered" :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$vuetify.breakpoint.sm ? '70vw' : $vuetify.breakpoint.md ? '50vw' : '40vw'"
    @input="submitAnswerAndCloseDialog" :content-class="'app-dialog survey-dialog ' + (isMobileOnly ? 'mobile' : '')" persistent>

    <v-card class="app-dialog-content">

      <v-toolbar dense class="app-dialog-header">
        <v-toolbar-title>
          <app-tooltip>
            {{ survey.surveyTitle }}
            <template v-slot:tooltip> {{ survey.surveyTitle }}</template>
          </app-tooltip>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="submitAnswerAndCloseDialog">
          <v-icon small>fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="app-dialog-body">
        <v-form ref="surveyForm" @submit.prevent>
          <div :class="isMobileOnly ? 'text-h6 pl-2 pt-2 titletext' : 'text-h5 pl-2 pt-2 titletext'">
            {{ survey.surveyText }}
          </div>

          <v-radio-group v-model="selectedAnswer">
            <div v-for="answer in survey.answers" :key="answer.answerId">
              <v-radio :label="answer.answer" :value="answer" class="mb-2"></v-radio>
            </div>
          </v-radio-group>
          <div>
            <app-text-area v-if="showUserInputElements" v-model="optionalText" :counter="128" clearable />
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions class="app-dialog-footer">
        <v-spacer></v-spacer>
        <v-btn v-if="showUserInputElements" color="primary" @click="submitAnswerAndCloseDialog(selectedAnswer)">
          {{ $t('surveys.sendAnswer') }}
        </v-btn>
        <v-btn color="secondary" @click="submitAnswerAndCloseDialog"> {{ $t('buttons.close') }}
        </v-btn>
      </v-card-actions>

    </v-card>

  </v-dialog>
</template>

<script>
import uiMixin from '@/mixins/ui-mixin';
import { UserSurveyAnswerModel, UserSurveyDto } from '@/models/surveys.models';

import AppTextArea from '@/components/Common/AppTextArea.vue';

import { surveysService } from '@/services/survey.service';
import AppTooltip from '@/components/Common/AppTooltip.vue';

export default {
  name: 'SurveyDialog',
  mixins: [uiMixin],
  components: {
    AppTooltip,
    AppTextArea
  },
  inject: ['isMobileOnly'],
  data() {
    return {
      isSurveyClosed: false,
      selectedAnswer: null,
      optionalText: ''
    };
  },
  props: {
    survey: UserSurveyDto
  },
  computed: {
    isDialogRendered() {
      return this.survey && !this.isSurveyClosed;
    },
    showUserInputElements() {
      return this.selectedAnswer && this.selectedAnswer.isUserInput;
    }
  },
  methods: {
    async close() {
      await this.submitAnswer();
      this.closeDlg();
    },
    closeDlg() {
      this.isSurveyClosed = true;
    },
    async submitAnswerAndCloseDialog(data) {
      let result = await this.submitAnswer(data);
      if (result) this.closeDlg();
    },
    async submitAnswer(data) {
      let isValid = this.$refs.surveyForm.validate();
      if (!isValid) return false;

      const model = new UserSurveyAnswerModel({
        surveyGuid: this.survey.surveyGuid,
        answerId: data?.answerId || null,
        answerText: data?.isUserInput ? this.optionalText : ''
      });

      await surveysService.addSurveyAnswer(model);

      return true;
    }
  },
  watch: {
    selectedAnswer(newVal, oldVal) {
      if (newVal !== oldVal && (newVal && !newVal.isUserInput)) {
        this.submitAnswer(newVal).then(() => this.closeDlg());
      }
    }
  }
};
</script>
